<template>
	<div :class="shovValidate ? 'mainContainer show' : 'mainContainer'">
		<div :class="valid ? 'dropdownWrapper complete' : 'dropdownWrapper incomplete'">
			<div :class='opened ? "v_dropdown active" : "v_dropdown"'>
				<div class="value" @click='opener' v-html='text'></div>
				<!-- <span class="focus-bg"></span> -->
				<div class='options'>
					<div class="overflow">
						<div
						v-for='opt in data.options'
						:class='active == opt.value ? "opt active" : "opt"'
						@click='setActive(opt)'
						v-html='opt.text'>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
module.exports = {
	props: ['data', 'countryCode'],

	data() {
		return {
			opened: false,
			text: this.data ? (this.data.value ? this.data.value : this.data.placeholder) : "",
			active: this.data ? this.data.options[0].value : '',
			name: this.data ? this.data.name : '',
			valid: false,
			shovValidate: false
		}
	},

	watch: {

		countryCode() {
			this.active = this.countryCode;

			for(let i = 0; i < this.data.options.length; i++) {
				if(this.data.options[i].value == this.countryCode) {
					this.text = this.data.options[i].text;
					// console.log(this.data.option.active);
					break;
				}
			}
		}
	},

	methods: {
		opener() {
			this.opened = !this.opened;
		},

		setActive(opt) {
			this.active = opt.value;
			this.opened = false;
			this.text = opt.text;

			this.$emit('changed', {
				name: this.name,
				value: this.active
			});
			this.valid = true;
			this.shovValidate = true;
		},

		validate() {
			this.shovValidate = true;
			// console.log('this.shovValidate');
		}
	},

	mounted() {
		setTimeout(() => {
			// console.log('name = ' + this.name + '    value = ' + this.active);
			this.$emit('changed', {
				name: this.name,
				value: this.active
			})
		}, 100);

		setTimeout(function () {
			let i = 10;
			$('.mainContainer').each(function(){
				$(this).css('z-index', i);
				i--;
			});
		}, 0);

		for(let i = 0; i < this.data.options.length; i++) {
			if(this.data.options[i].active) {
				this.active = this.data.options[i].value;
				// console.log(this.data.options[i].value);
				break;
			}
		}

		if(this.data.value){
			this.valid = true;
			this.shovValidate = true;
		}

		document.addEventListener('click', e => {
			if(!$(e.target).closest(this.$el).length) {
				this.opened = false;
			}
		})
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.mainContainer{
	position: relative;
	clear: both;
	.dropdownWrapper{
		&:after {
			content: '';
			display: flex;
			position: absolute;
			top: calc(50% - 11px);
			left: 0;
			font-size: 14px;
			width: 25px;
			align-items: center;
			justify-content: center;
			z-index: 1;
			@include pointer-events(none);
			opacity: 0;
			@include single-transition;
		}
	}
	&.show{
		.incomplete {
			&:after {
				@include fa($fa-times);
				opacity: 1;
				color: red;
				z-index: 5;
			}
		}
		// .complete {
		// 	&:after {
		// 		@include fa($fa-check);
		// 		opacity: 1;
		// 		color: green;
		// 	}
		// }
	}
}
.v_dropdown {
	display: flex;
	position: relative;
	// margin: 0 0 20px;
	margin-bottom: 13px;
	width: 100%;
	// color: #fff !important;
	@include m_up {
		width: auto;
		// margin: 0 30px 0 0;
	};

	.label {
		font-size: 15px;
		color: #000;
		padding: 0 4px 0 0;
	}

	.value ~ .focus-bg{
		&:before, &:after{
			content: "";
			position: absolute;
			left: 50%;
			top: 50%;
			width: 0;
			height: 0;
			background-color: rgba(#ededed, .15);
			transition: 0.3s;
			z-index: -1;
		}
		&:after{
			left: auto;
			right: 50%;
			top: auto;
			bottom: 50%;
		}
	}



	.value {
		font-size: rem(16);
		font-weight: 500;
		color: #24394e;
		margin: 0;
		position: relative;
		cursor: pointer;
		color: #282828;
		width: 100%;
		border: 1px solid #24394e;
		height: 50px;
		border-radius: 25px;
		padding: 0 36px 0 20px;
		// white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		display: flex;
		align-items: center;
		z-index: 4;
		background-color: white;
		&:after {
			// @include fa($fa-chevron-down);
			content: '';
			background-image: url('../img/arrLL.png');
			width: 11px;
			height: 11px;
			background-size: contain;
			background-repeat: no-repeat;
			position: absolute;
			display: block;
			right: 19px;
			top: calc(50% - 2px);
		}

		&:before {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			right: 0;
			// border-bottom: 1px dotted #858585;
			bottom: 0;
		}
	}

	.options {
		position: absolute;
		top: 20px;
		left: 0;
		width: 100%;
		background-color: #fff;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		border: 1px solid #24394e;
		@include single-transition;
		opacity: 0;
		@include pointer-events(none);
		@include translateY(10px);
		z-index: 3;
		padding-top: 30px;

		&:before {
			content: '';
			display: block;
			width: 19px;
			height: 10px;
			// background: url('#{$imgPathSCSS}dda.png') no-repeat center;
			position: absolute;
			left: 10px;
			bottom: calc(100% - 1px);
		}

		.overflow {
			max-height: 250px;
			overflow: auto;
			padding: 10px;
		}

		.opt {
			color: #282828;
			font-size: 16px;
			font-weight: 500;
			line-height: 17px;
			border: 1px solid #fff;
			border-radius: 8px;
			margin: 0 0 2px;
			padding: 12px 10px 10px;
			cursor: pointer;
			@include single-transition;

			&:hover {
				border-color: #ACB1B5;
			}

			&.active {
				border-color: #2967a7 !important;
				color: #2967a7;
			}
		}
	}
	&.active {
		.options{
			opacity: 1;
			@include pointer-events(auto);
			@include translateY(0px);
		}
		.focus-bg{
			&:before{
				transition: 0.3s;
				width: 50%;
				left: 0;
				top: 0;
				height: 100%;
				z-index: 0;
			}
			&:after{
				transition: 0.3s;
				width: 50%;
				height: 100%;
				bottom: 0;
				right: 0;
				z-index: 0;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// dropdown.vue?13a98c0e